<template>
	<footer class="main-footer">
		<div class="copyright">
			<div class="left">&copy;{{ (new Date()).getFullYear() }} Vulgar Cooking. All Rights Reserved.</div>
			<div class="right">Site Design & Development By <a href="https://pixelcore.dev" target="_blank" rel="noopener">Pixelcore Development</a></div>
		</div>
	</footer>
</template>

<script>
	export default {

	}
</script>